function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/yup/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 165
// module chunks = 3 9